import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { useContext } from 'react';
import { TranslationContext } from "../../../context/translations/translations-context";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";
import { alcyoneContactInformation, lusisContactInformation } from "../../../utils/contactInformation";
import { calculateTotalExperienceDuration } from "../../../utils/calculateDatesDifference";
import { formatPrenom } from "../../../utils/formatPrenom";
import { getInitials } from "../../../utils/getInitials";

export default function Header() {
    const { translations } = useContext( TranslationContext );

    const { isAlcyone, isEuropass, isAnonymous, logoSrc, logoLabel } = useResumeProperties();
    const { user: userData, totalExperienceDuration, experiences } = useResumeDocumentSection();

    const { phoneNumber, emailAddress, webSite, postalAddress } = isAlcyone
        ? alcyoneContactInformation
        : lusisContactInformation;
    const isLusis = ( logoLabel || "" ).toLowerCase().includes( "lusis" )
        || ( logoSrc || "" ).toLowerCase().includes( "lusis" );
    const logoHeight = isEuropass ? "42" : ( isLusis ? "75" : "150" );

    const {
        years: experienceYears,
        months: experienceMonths,
    } = calculateTotalExperienceDuration( experiences, totalExperienceDuration );

    return (
        <header>
            <MDBRow style={ { backgroundColor: isEuropass && "#f5f5f5" } }>
                <MDBCol md="6" className="text-start">
                    { isAlcyone && <img
                        src="/spinner-alcyone.png"
                        className="spinner-cv"
                        height="100"
                        alt=""
                        style={ {
                            marginLeft: "50px",
                            marginTop: "40px",
                        } }
                    /> }
                    <div
                        className="content-div"
                        style={ {
                            marginTop: isEuropass ? "-90px" : "-62px",
                            marginLeft: isEuropass ? "72px" : "91px",
                            width: "400px",
                        } }
                    >
                        { isAnonymous ? (
                            <p className="h4">
                                <span className="fw-bold">
                                    { getInitials( userData.firstName ) }{ ' ' }{ getInitials( userData.lastName, true ) }
                                </span>
                            </p>
                        ) : (
                            <p className="h4"
                               style={ { color: isEuropass && "#565656" } }>
                                 <span className="fw-bold">
                                     { formatPrenom( userData?.firstName ) }{ ' ' }{ userData?.lastName?.toUpperCase() }
                                 </span>
                            </p>
                        ) }
                    </div>
                </MDBCol>
                <MDBCol md="6" className="header-cv text-end">
                    <img
                        src={ isEuropass ? "/europass-cv.png" : logoSrc }
                        className="header-cv"
                        height={ logoHeight }
                        alt=""
                        style={ {
                            marginTop: "40px",
                            marginRight: "70px",
                        } }
                    />
                    { !isEuropass && (
                        <p style={ {
                            color: "#808080",
                            fontSize: "10px",
                            marginRight: "70px",
                            marginTop: "28px",
                            marginBottom: 0,
                        } }>
                            { translations.pdf.workExperienceLabel }{ ' ' }
                            { translations.pdf.workExperienceTemplate
                                .replace( "{years}", experienceYears )
                                .replace( "{months}", experienceMonths ) }
                        </p>
                    ) }
                </MDBCol>
                { isEuropass && (
                    <hr style={ {
                        color: "#979797",
                        height: "2px",
                        width: "86%",
                        marginLeft: "82px",
                        marginTop: "20px",
                        marginBottom: "20px"
                    } }/>
                ) }
                { isEuropass && (
                    <div style={ {
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        flexWrap: "wrap",
                        marginLeft: "72px",
                        marginBottom: "20px"
                    } }>
                        <span style={ { color: "#565656", marginLeft: "72px", fontSize: "10px", margin: 0 } }>
                            <strong>{ translations.pdf.phoneNumberLabel }</strong>{ ' ' }{ phoneNumber }
                        </span>
                        <span style={ { color: "#565656", marginLeft: "72px", fontSize: "10px", margin: 0 } }>
                            <strong>{ translations.pdf.emailAddressLabel }</strong>{ ' ' }{ emailAddress }
                        </span>
                        <span style={ { color: "#565656", marginLeft: "72px", fontSize: "10px", margin: 0 } }>
                            <strong>{ translations.pdf.webSiteLabel }</strong>{ ' ' }{ webSite }
                        </span>
                        <span style={ { color: "#565656", marginLeft: "72px", fontSize: "10px", margin: 0 } }>
                            <strong>{ translations.pdf.postalAddressLabel }</strong>{ ' ' }{ postalAddress }
                        </span>
                    </div>
                ) }
            </MDBRow>
        </header>
    );
}
